import { responseStatus } from "../constants";
import { ApiPaths } from "../helpers/api";
import { ChucNangResponse, ChucNangSelectBox, PhanChucNangRequest } from "../models/chucnang/ChucNang";
import intance from "../utils/axios";

export const layDanhSachChucNangSelectTree = async () => {
    var data: Array<ChucNangSelectBox> = [];
    await intance.get(ApiPaths.chucNang.danhSachTree)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = convertDataSelect(res.data.duLieu)
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
};

const convertDataSelect = (data: any) => {
    let chidlrenArr: Array<ChucNangSelectBox> = [];
    if (data) {
        chidlrenArr = data.map((_item: any) => {
            return {
                value: _item?.id,
                title: _item?.tenChucNang,
                children: convertDataSelect(_item?.children),
            }
        })
    }
    return chidlrenArr;
}

export const layDanhSachChucNangTreeView = async () => {
    var data: Array<ChucNangResponse> = [];
    await intance.get(ApiPaths.chucNang.danhSachTree)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = res.data.duLieu
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
};

export const xoaChucNang = async (id: number) => {
    let rs = false;
    await intance.post(ApiPaths.chucNang.xoa + "?id=" + id)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                rs = true;
            }
        })
        .catch((err) => {
            throw err;
        });
    return rs;
};

export const layChiTietChucNang = async (id: number) => {
    var data: ChucNangResponse | null = null;
    await intance.get(ApiPaths.chucNang.chitiet + "?id=" + id)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = res.data.duLieu;
            } else {
                throw Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
};

export const luuChucNang = async (data: any) => {
    await intance.post(ApiPaths.chucNang.luu, data)
        .then(res => {
            if (res.data.trangThai != responseStatus.thanhCong) {
                throw new Error(res.data.thongBao);
            }
        })
        .catch(err => {
            throw err;
        });
};

export const layDSChucNangTheoIdQuyen = async (idQuyen: number) => {
    var data: Array<ChucNangResponse> = [];
    await intance.get(ApiPaths.chucNang.dsTheoIdQuyen + "?idQuyen=" + idQuyen)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = res.data.duLieu;
            } else {
                throw Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
};

export const layDSChucNangRiengTheoIdNguoiDung = async (idNguoiDung: number) => {
    var data: Array<ChucNangResponse> = []
    await intance.get(ApiPaths.chucNang.layDsChucNangRieng + "?idNguoiDung=" + idNguoiDung)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = res.data.duLieu;
            }
            else {
                throw Error(res.data.thongBao);
            }
        })
        .catch((error) => {
            throw error;
        })
    return data;
}

export const layDsChucNangDiKemQuyen = async (idNguoiDung: number) => {
    var data: Array<ChucNangResponse> = [];
    await intance.get(ApiPaths.chucNang.layDsChucNangDiKemQuyen + "?idNguoiDung=" + idNguoiDung)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = res.data.duLieu
            }
            else {
                throw Error(res.data.thongBao)
            }
        })
        .catch((error) => {
            throw error;
        })
    return data;
}

export const luuDsChucNangRieng = async (request: PhanChucNangRequest) => {
    var rs = false;
    await intance.post(ApiPaths.chucNang.luuChucNangRieng, request)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                rs = true;
            }
        })
        .catch((error) => {
            throw error;
        })
    return rs;
}